class NullAccountSwitcherLoader {
  serialize() {
    return {};
  }

  get activeAccount() {
    return {
      serialize: () => ({ id: null })
    };
  }

  get activePublication() {
    return {
      serialize: () => ({ id: null })
    };
  }

  get publications() {
    return [{ id: null }];
  }
}

export default NullAccountSwitcherLoader;
